import {
  VOUCHER_DASHBOARD_DETAILS_SUCCESS,
  VOUCHER_DASHBOARD_DETAILS_FAILED,
  RESET_VOUCHER_DASHBOARD_DETAILS,
  LOADING_VOUCHER_DASHBOARD_DETAILS,
  NETWORK_ERROR_VOUCHER_DASHBOARD_DETAILS,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
  purchaseTotal: "",
  redeemTotal: "",
  activeTotal: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_VOUCHER_DASHBOARD_DETAILS: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
        purchaseTotal: "",
        redeemTotal: "",
        activeTotal: "",
      };
    }
    case VOUCHER_DASHBOARD_DETAILS_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
        purchaseTotal: "",
        redeemTotal: "",
        activeTotal: "",
      };
    }
    case VOUCHER_DASHBOARD_DETAILS_SUCCESS: {
      const purchaseTotal =
        action.payload.voucherDetails.purchaseVoucher &&
        (Array.isArray(action.payload.voucherDetails.purchaseVoucher)
          ? action.payload.voucherDetails.purchaseVoucher.reduce(
              (x, y) => x + Number(y.amount * y.count),
              0
            )
          : Array(
              action.payload.voucherDetails.purchaseVoucher.reduce(
                (x, y) => x + Number(y.amount * y.count),
                0
              )
            ));

      const redeemTotal =
        action.payload.voucherDetails.redeemVoucher &&
        (Array.isArray(action.payload.voucherDetails.redeemVoucher)
          ? action.payload.voucherDetails.redeemVoucher.reduce(
              (x, y) => x + Number(y.amount * y.count),
              0
            )
          : Array(action.payload.voucherDetails.redeemVoucher).reduce(
              (x, y) => x + Number(y.amount * y.count),
              0
            ));

      const activeTotal =
        action.payload.voucherDetails.activeVoucher &&
        (Array.isArray(action.payload.voucherDetails.activeVoucher)
          ? action.payload.voucherDetails.activeVoucher.reduce(
              (x, y) => x + Number(y.amount * y.count),
              0
            )
          : Array(action.payload.voucherDetails.activeVoucher).reduce(
              (x, y) => x + Number(y.amount * y.count),
              0
            ));

      console.log("DASHBOARD purchaseTotal = ", purchaseTotal);
      console.log("DASHBOARD redeemTotal = ", redeemTotal);
      console.log("DASHBOARD activeTotal = ", activeTotal);

      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
        purchaseTotal: purchaseTotal,
        redeemTotal: redeemTotal,
        activeTotal: activeTotal,
      };
    }
    case NETWORK_ERROR_VOUCHER_DASHBOARD_DETAILS: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: true,
        data: {},
        purchaseTotal: "",
        redeemTotal: "",
        activeTotal: "",
      };
    }
    case RESET_VOUCHER_DASHBOARD_DETAILS: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
